<template>
  <div class='comp-chosen'>
    <div class='chosen-items'>
      <div
        v-for='(entry, idx) in entries'
        :key='entry'
        class='chosen-item'>
        <div class='entry-name'>{{entry}}</div>
        <div
          @click='() => dropEntry(idx)'
          class='entry-remove'></div>
      </div>
    </div>
    <slot :addEntry='addEntry'>
      <input
        :value='modelValue'
        @input="$emit('update:modelValue', $event.target.value)"
        @keydown.enter.prevent.stop='addEntry'
        required
        ref='input'
        type='text'
        class='form-control'
        :minlength='minlength'
        :maxlength='maxlength'
        :placeholder='LANG.chosenPlaceholder' />
    </slot>

    <div class='helper form-hint'>
      <slot name="helper" :isValidInput='isValidInput'>
        <div v-if='!isValidInput' class='error'>{{ LANG.chosenInputNotValid }}</div>
        <div v-else>{{ LANG.chosenHelpText }}</div>
        <div>{{ remaining }}</div>
      </slot>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import LANG from '@/lang/eng';
import { showToast } from '@/utils/tools';
import { mapState, mapActions } from 'vuex';

export default defineComponent({
  props: {
    modelValue: {
      type: String,
      required: false,
      default: '',
    },
    entries: {
      type: Array,
      default: () => [],
    },
    existing: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      regex: /^[^~,|\\/<>"']+$/,
      minlength: 1,
      maxlength: 35,
    };
  },
  computed: {
    ...mapState(['LANG']),
    isValidInput() {
      const { modelValue, regex } = this;

      const testValue = modelValue.trim();

      return modelValue
        ? regex.test(testValue)
        : true;
    },
    remaining() {
      return `${this.modelValue.length} / ${this.maxlength}`;
    },
  },
  methods: {
    ...mapActions([]),
    existInBothLists() {
      const { existing, entries, modelValue } = this;
      const inNewList = entries.indexOf(modelValue.trim()) !== -1;
      const inCurrent = existing.indexOf(modelValue.trim()) !== -1;

      return inNewList || inCurrent;
    },
    addEntry() {
      const { modelValue, entries } = this;
      const exists = this.existInBothLists();

      const ok = modelValue.trim() && !exists && this.isValidInput;
      if (ok) {
        entries.push(modelValue.trim());
        this.$emit('update:modelValue', '');
      }

      if (exists) {
        showToast(LANG.chosenItemAlreadyExists, 1);
      }

      return ok;
    },
    dropEntry(idx) {
      this.entries.splice(idx, 1);
    },
  },
});
</script>

<style scoped lang='scss'>
.chosen-items {
  margin-bottom: .5em;
  max-height: 300px;
  overflow: auto;

  &:after {
    content: '';
    display: block;
    clear: both;
  }

  .chosen-item {
    position: relative;
    float: left;
    display: table;
    align-items: center;

    margin: 3px 5px 3px 0;
    padding: 3px 10px;

    border: 1px solid #aaa;
    border-color: $blue;
    border-radius: 2px;
    color: $blue;

    .entry-name {
      display: table-cell;
      padding-right: 1.5em;
      word-break: break-word;
    }

    .entry-remove {
      cursor: pointer;
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      right: 10px;
      width: 10px;
      height: 15px;
      background: url('/imperia/images/times.svg') no-repeat;
    }
  }
}
</style>
